<div class="search-bar">
  <input
    type="text"
    [formControl]="searchControl"
    [placeholder]="placeholder"
  />
  <div class="icon">
    <img src="assets/static/icons/search.svg" alt="Search" />
  </div>
</div>
